import React from 'react';
import { classes } from './Asterisk.st.css';
export const Asterisk = ({ dataHook, ...props }) => (React.createElement("span", { className: classes.root, "aria-hidden": "true", "data-hook": dataHook, ...props }, "*"));
//# sourceMappingURL=Asterisk.js.map